module.exports = __webpack_public_path__ + "static/media/box.233c23d9.svg";